export const CONTACT_SUBJECT_VALUES = ["1", "2", "3", "4", "5"] as const;

export type ContactSubjectValue = (typeof CONTACT_SUBJECT_VALUES)[number];

export const COMPANY_CONTACT_SUBJECT: ContactSubjectValue = "4";

export const CONTACT_SUBJECT_OPTIONS: ReadonlyArray<{
    value: ContactSubjectValue;
    labelKey: string;
}> = [
    { value: "1", labelKey: "contact.label.subject.1" },
    { value: "2", labelKey: "contact.label.subject.2" },
    { value: "3", labelKey: "contact.label.subject.3" },
    { value: "4", labelKey: "contact.label.subject.4" },
    { value: "5", labelKey: "contact.label.subject.5" },
];
